import api from '../config/api';

const configuracionTasaNocturnaService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-tasa-nocturna/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener configuración de tasa nocturna:', error);

      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }

      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de tasa nocturna',
      };
    }
  },

  async actualizarConfiguracion(empresaId, { activo, horas_tasa_nocturna, calcular_en_planilla }) {
    try {
      const payload = {
        activo,
        horas_tasa_nocturna,
      };
      if (calcular_en_planilla !== undefined) {
        payload.calcular_en_planilla = calcular_en_planilla;
      }
      const response = await api.put(`/configuracion-tasa-nocturna/empresa/${empresaId}`, payload);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar configuración de tasa nocturna:', error);

      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }

      if (error.response?.status === 422) {
        return {
          success: false,
          error: 'Datos de entrada inválidos',
          details: error.response.data.details,
        };
      }

      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración de tasa nocturna',
      };
    }
  },

  async verificarEstado(empresaId) {
    try {
      const response = await api.get(`/configuracion-tasa-nocturna/empresa/${empresaId}/estado`);
      return response.data;
    } catch (error) {
      console.error('Error al verificar estado de tasa nocturna:', error);

      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }

      return {
        success: false,
        error: error.response?.data?.error || 'Error al verificar estado de tasa nocturna',
      };
    }
  },
};

export default configuracionTasaNocturnaService;
